import { ref } from "vue";

const progress = ref(0);
const selection = ref(false);
const burst = ref(0);
const bursting = ref(false);

export const useOpinionScene = () => ({ progress, selection, burst, bursting });
